"use client";
import ArrowSwiperWithInfoSection, {
  ArrowSwiperWithInfoProps,
} from "@cc/arrow-swiper-with-info-section";
import ArrowSlideInfo from "@cc/cards/arrow-slide-info";
import { ArrowSlideDefaultImageProps } from "@cc/cards/arrow-slide-default-image";
import { H3_1 } from "@theme/components/typography.fontvariant";

export interface ActsOfProgressProps {
  title?: string;
  data: (ArrowSwiperWithInfoProps<
    typeof ArrowSlideInfo
  >["data"][number]["data"][number] &
    ArrowSlideDefaultImageProps)[];
  navId?: string;
}

const ActsOfProgress = (props: ActsOfProgressProps) => {
  const { title, data, navId } = props;
  return (
    <ArrowSwiperWithInfoSection
      data={data}
      SwiperKey={ActsOfProgress.name}
      SectionWrapperProps={{
        navId: navId || "Acts of Progress",
        color: "secondary.main",
        SectionProps: {
          bgcolor: "primary.main",
        },
        SectionHeaderProps: {
          title,
        },
      }}
      SwiperProps={{
        navigation: true,
      }}
      ArrowSlideInfoProps={{
        SlotProps: {
          TitleTypographyProps: {
            fontSize: H3_1,
          },
          ButtonProps: {
            color: "secondary",
          },
          DescriptionTypographyProps: {
            textAlign: "justify",
          },
        },
      }}
    />
  );
};

export default ActsOfProgress;
